import React, { useState, useEffect } from 'react';
import Layout from "../temp/layout/Layout";
import { Select, Input, Form, Collapse, Carousel, Badge } from "antd";
import Counter from "../../components/global/counter/Counter";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import stateDistricts from '../../assets/data/stateDistricts.jsx';
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import { AddStudentApi } from "../../api/request/Student.js";
import AOS from 'aos';
import { Link } from 'react-router-dom';
import toast from "react-hot-toast";
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import { 
    FaGraduationCap, FaUserTie, FaUsers, FaChalkboardTeacher, 
    FaFileAlt, FaCreditCard, FaCalendarCheck, FaLaptopCode,
    FaBrain, FaTasks, FaBookReader, FaClipboardCheck, FaVideo,
    FaRocket, FaShieldAlt, FaChartLine, FaMobileAlt, FaCloud,
    FaLock, FaCheckCircle, FaStar, FaArrowRight
} from 'react-icons/fa';

const plans = [
    {
        name: "Starter Trial",
        duration: "3 Month",
        Yearly_price: "Free",
        Monthly_price: "Free",
        users: "Unlimited",
        popular: false,
        featured: true,
        details: [
            "Unlimited number of users with unrestricted access.",
            "Full access to the Web App, equipped with all core and premium features.",
            "Dedicated Admin Mobile Application for smooth administrative control.",
            "Specialized Mentor Mobile App to manage and guide student progress efficiently.",
            "Student Mobile App with personalized learning experiences.",
            "1 customized Email Domain Service to manage professional communication.",
            "Document Redundancy Policy ensuring secure backup for up to 7 years.",
            "Document Storage Capacity: 350 GB to store academic and administrative records safely.",
            "Complimentary Configuration Support for 3 Years to ensure a hassle-free setup and operational continuity.",
        ],
    },
    {
        name: "Core Plan",
        Yearly_price: "4,999",
        Monthly_price: "549",
        users: "100",
        popular: true,
        details: [
            "Supports up to 100 active users including students, mentors, and administrators.",
            "Access to the Web App, designed to simplify academic and administrative tasks.",
            "1 Email Domain Service for seamless communication across your institution.",
            "Secure Document Redundancy Policy for 1 Year, safeguarding essential academic records.",
            "Configuration Support provided for 1 Year to assist with integration and maintenance.",
        ],
    },
    {
        name: "Elevate Plan",
        Yearly_price: "6,499",
        Monthly_price: "599",
        users: "200",
        popular: false,
        details: [
            "Accommodates up to 200 users with full platform access.",
            "Complete Web App Access for managing academic workflows effectively.",
            "Access to the Mentor Mobile App, allowing mentors to guide, assess, and interact with students on the go.",
            "1 Professional Email Domain Service included.",
            "Document Storage up to 100 GB to securely handle learning materials and administrative documents.",
            "Document Redundancy Policy extended to 3 Years for better data protection and compliance.",
            "Configuration Support for 1 Years to ensure smooth platform operations and upgrades.",
        ],
    },
];

const { TextArea } = Input;
const { Option } = Select;
const { Panel } = Collapse;

// Comprehensive Features List
const features = [
    {
        icon: <FaFileAlt className="text-4xl" />,
        title: "Admission Form Management",
        description: "Streamlined digital admission forms with automated validation and instant submission. Reduce paperwork and processing time by 90%.",
        color: "from-blue-500 to-blue-600"
    },
    {
        icon: <FaClipboardCheck className="text-4xl" />,
        title: "Admission Form Review",
        description: "AI-powered review system that helps administrators quickly process and approve admission applications with intelligent recommendations.",
        color: "from-purple-500 to-purple-600"
    },
    {
        icon: <FaCalendarCheck className="text-4xl" />,
        title: "Entrance Exam Scheduling",
        description: "Automated exam scheduling with conflict detection, room allocation, and automated notifications to students and invigilators.",
        color: "from-green-500 to-green-600"
    },
    {
        icon: <FaLaptopCode className="text-4xl" />,
        title: "Online Entrance Exam",
        description: "Secure, proctored online examination system with real-time monitoring, anti-cheating measures, and instant result generation.",
        color: "from-red-500 to-red-600"
    },
    {
        icon: <FaCreditCard className="text-4xl" />,
        title: "Admission Fee Payment",
        description: "Multiple payment gateway integration with instant receipts, payment tracking, and automated reminders for pending payments.",
        color: "from-yellow-500 to-yellow-600"
    },
    {
        icon: <FaChalkboardTeacher className="text-4xl" />,
        title: "Class Management",
        description: "Complete class organization with timetable management, subject allocation, and real-time class capacity tracking.",
        color: "from-indigo-500 to-indigo-600"
    },
    {
        icon: <FaBookReader className="text-4xl" />,
        title: "Class Operations",
        description: "Manage daily class activities, attendance, assignments, and academic schedules with automated workflows and notifications.",
        color: "from-pink-500 to-pink-600"
    },
    {
        icon: <FaUserTie className="text-4xl" />,
        title: "Teacher Management",
        description: "Comprehensive teacher profiles, performance tracking, workload management, and professional development tracking.",
        color: "from-teal-500 to-teal-600"
    },
    {
        icon: <FaUsers className="text-4xl" />,
        title: "Student Management",
        description: "Complete student lifecycle management from admission to graduation with detailed academic records and performance analytics.",
        color: "from-orange-500 to-orange-600"
    },
    {
        icon: <FaGraduationCap className="text-4xl" />,
        title: "Administration",
        description: "Centralized administrative control with role-based access, comprehensive reporting, and institutional data management.",
        color: "from-cyan-500 to-cyan-600"
    },
    {
        icon: <FaBrain className="text-4xl" />,
        title: "AI Mentorship",
        description: "Revolutionary AI-powered mentorship system that provides personalized learning paths, study recommendations, and performance insights.",
        color: "from-violet-500 to-violet-600"
    },
    {
        icon: <FaTasks className="text-4xl" />,
        title: "Assignment Management",
        description: "Digital assignment creation, submission, grading, and feedback system with plagiarism detection and automated grading.",
        color: "from-amber-500 to-amber-600"
    },
    {
        icon: <FaClipboardCheck className="text-4xl" />,
        title: "Online Exam System",
        description: "Comprehensive online examination platform with question banks, auto-grading, detailed analytics, and secure exam delivery.",
        color: "from-emerald-500 to-emerald-600"
    },
    {
        icon: <FaVideo className="text-4xl" />,
        title: "Online Classes",
        description: "Integrated virtual classroom with video conferencing, screen sharing, interactive whiteboard, and session recording capabilities.",
        color: "from-rose-500 to-rose-600"
    },
];

const testimonials = [
    {
        quote: "The AI-powered automation and analytics completely transformed our administration! We've reduced manual work by 80%.",
        name: "Principal Kaur",
        designation: "Delhi Public School",
        rating: 5
    },
    {
        quote: "Fee management is now completely headache-free, and our teachers absolutely love the intuitive interface. Best investment we've made!",
        name: "Admin Ms. Das",
        designation: "St. Xavier's College",
        rating: 5
    },
    {
        quote: "Our data is secure, parents are much happier with real-time communication features, and student engagement has increased significantly.",
        name: "Director Sharma",
        designation: "Modern Academy",
        rating: 5
    },
    {
        quote: "The AI mentorship feature is a game-changer. It provides personalized insights that help us guide students more effectively.",
        name: "Dr. Patel",
        designation: "Elite Educational Institute",
        rating: 5
    }
];

const faqs = [
    {
        q: "Is Educational Eternity cloud-based and secure?",
        a: "Yes, our platform is 100% cloud-based with high-grade security. All data is encrypted, backed up regularly, and compliant with international data protection standards. Your institution's data is safe and accessible from anywhere, anytime."
    },
    {
        q: "Can parents track fee payments and academic progress?",
        a: "Absolutely! Parents have their own dedicated portal where they can view fee statements, make online payments, download receipts, track their child's attendance, grades, assignments, and receive real-time notifications about important updates."
    },
    {
        q: "Is data migration from existing systems supported?",
        a: "Yes, our expert onboarding team provides complete data migration support. We help you seamlessly transfer all your existing student records, teacher data, academic history, and administrative information to Educational Eternity without any data loss."
    },
    {
        q: "How does the AI Mentorship feature work?",
        a: "Our AI Mentorship system analyzes student performance, learning patterns, and academic history to provide personalized study recommendations, identify learning gaps, suggest improvement areas, and create customized learning paths for each student."
    },
    {
        q: "Can we customize the system according to our institution's needs?",
        a: "Yes, Educational Eternity is highly customizable. We offer configuration support to tailor the system according to your institution's specific requirements, workflows, and academic structure."
    },
    {
        q: "What devices are supported?",
        a: "Educational Eternity works seamlessly on all devices - desktop computers, laptops, tablets, and smartphones. We have dedicated mobile apps for Android and iOS, plus a fully responsive web application."
    },
    {
        q: "Is training provided for staff and administrators?",
        a: "Yes, we provide comprehensive training sessions for all users - administrators, teachers, and staff. Our team ensures everyone is comfortable using the system before going live."
    },
    {
        q: "What kind of support do you offer?",
        a: "We offer 24/7 technical support via email, phone, and live chat. Our support team is always ready to help with any questions or issues. We also provide regular updates and feature enhancements."
    }
];

const HomePage = () => {
    const [form] = Form.useForm();
    const [activeTab, setActiveTab] = useState("Smart School Suite");
    const [isOpenPlanModal, setIsOpenPlanModal] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [selectedState, setSelectedState] = useState('');
    const [districtOptions, setDistrictOptions] = useState([]);
    const [billingCycle, setBillingCycle] = useState("monthly");
    const [initialValues, setInitialValues] = useState({ 
        First_Name: '', Last_Name: '', Contact_Number: '', Mother_Name: '', 
        Father_Name: '', Class: '', Class_Code: '', State: '', District: '', Secondary_Contact: '' 
    });

    useEffect(() => {
        AOS.init({ 
            duration: 1000, 
            once: true,
            offset: 100,
            easing: 'ease-in-out'
        });
    }, []);

    const openAddPlanModal = () => {
        form.resetFields();
        setInitialValues({ 
            First_Name: '', Last_Name: '', Contact_Number: '', Mother_Name: '', 
            Father_Name: '', Class: '', Class_Code: '', State: '', District: '', Secondary_Contact: '' 
        });
        setIsOpenPlanModal(true);
    }

    const handleFieldsChange = (_, allFields) => {
        const isChanged = allFields.some(field => field.touched);
        setIsFormChanged(isChanged);
    };

    const filterOption = (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    const handleStateChange = (value) => {
        setSelectedState(value);
        setDistrictOptions(stateDistricts[value] || []);
    };

    const handleSubmit = async (values) => {
        setIsSubmitLoading(true);
        let params = { ...values };
        try {
            const { data } = await AddStudentApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                setIsOpenPlanModal(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'An error occurred');
        } finally {
            setIsSubmitLoading(false);
        }
    };

    return (
        <div className="mx-auto overflow-hidden">
            <Helmet>
                <title>Best Education ERP System in India | AI-Powered School Management Software | Educational Eternity</title>
                <meta name="description" content="Educational Eternity - India's most advanced AI-powered Education ERP system. Complete school & college management software with admission forms, online exams, fee payment, class management, AI mentorship, and more. Transform your educational institution today!" />
                <meta name="keywords" content="Education ERP System, School ERP Software, College Management System, Education Management Software, School Management System India, AI-Powered Learning, Online Exam System, Admission Management, Fee Management System, Student Information System, Teacher Management, Class Management Software, Educational Technology, School Administration Software, Best ERP for Schools" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Best Education ERP System in India | AI-Powered School Management" />
                <meta property="og:description" content="Transform your educational institution with Educational Eternity - India's most advanced AI-powered Education ERP system." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.educationaleternity.com" />
            </Helmet>
            <Layout header={1} className="home-one" footer={1}>
                {/* Modern Hero Section */}
                <section className="relative min-h-[95vh] flex items-center justify-center overflow-hidden">
                    {/* Background Image */}
                    <div 
                        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                        style={{
                            backgroundImage: `url(assets/images/home1.jpg)`,
                        }}
                    ></div>
                    
                    {/* Dark Overlay for better text readability */}
                    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
                    
                    {/* Animated Light Effects */}
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-yellow-400/20 rounded-full filter blur-3xl animate-pulse"></div>
                        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-400/20 rounded-full filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                    </div>
                    
                    <div className="relative z-10 container mx-auto px-4 py-20 md:py-32">
                        <div className="max-w-6xl mx-auto text-center">
                            {/* Main Heading - Styled Attractively */}
                            <div data-aos="fade-up" data-aos-duration="1000" className="mb-8">
                                <div className="relative inline-block">
                                    <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight" style={{
                                        fontFamily: 'system-ui, -apple-system, sans-serif',
                                        letterSpacing: '-0.02em',
                                        lineHeight: '1.2'
                                    }}>
                                        <span className="block" style={{
                                            textShadow: '3px 3px 0px rgba(0,0,0,0.3), 6px 6px 20px rgba(0,0,0,0.5)',
                                            fontWeight: 800
                                        }}>
                                            Transform Education with
                                        </span>
                                        <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-wider mt-2" style={{
                                            textShadow: '4px 4px 0px rgba(0,0,0,0.4), 8px 8px 30px rgba(0,0,0,0.6)',
                                            fontWeight: 900,
                                            letterSpacing: '0.08em',
                                            lineHeight: '1.1'
                                        }}>
                                            AI-Powered ERP System
                                        </span>
                                    </h1>
                                </div>
                            </div>
                            
                            {/* Subtitle */}
                            <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="800" className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed font-medium" style={{
                                textShadow: '0 2px 10px rgba(0,0,0,0.5)'
                            }}>
                                India's most advanced Education Management System. Complete digital transformation for schools and colleges with 
                                <span className="font-bold text-yellow-300"> AI-driven insights</span>, 
                                <span className="font-bold text-pink-300"> automated workflows</span>, and 
                                <span className="font-bold text-purple-300"> seamless operations</span>.
                            </p>
                            
                            {/* CTA Buttons */}
                            <div data-aos="fade-up" data-aos-delay="300" className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
                                <button 
                                    onClick={openAddPlanModal}
                                    className="group relative px-10 py-5 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 text-white rounded-full text-base md:text-lg font-bold shadow-2xl hover:shadow-yellow-500/70 transform hover:scale-110 transition-all duration-300 flex items-center gap-2 overflow-hidden border-2 border-yellow-300/50"
                                >
                                    <span className="relative z-10 flex items-center gap-2">
                                        Schedule Free Demo 
                                        <FaArrowRight className="group-hover:translate-x-2 transition-transform" />
                                    </span>
                                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-500 via-pink-600 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity rounded-full"></div>
                                </button>
                        <Link to="/plans">
                                    <button className="px-10 py-5 bg-white/20 backdrop-blur-lg border-2 border-white/40 text-white rounded-full text-base md:text-lg font-bold shadow-xl hover:bg-white/30 hover:border-white/60 transform hover:scale-110 transition-all duration-300">
                                        View Pricing Plans
                            </button>
                        </Link>
                    </div>

                            {/* Trust Indicators */}
                            <div data-aos="fade-up" data-aos-delay="400" className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-5xl mx-auto">
                                {[
                                    { icon: <FaShieldAlt />, text: "High-Grade Security", color: "from-green-400 to-emerald-500", bgColor: "from-green-500/20 to-emerald-600/20" },
                                    { icon: <FaCloud />, text: "Cloud-Based", color: "from-blue-400 to-cyan-500", bgColor: "from-blue-500/20 to-cyan-600/20" },
                                    { icon: <FaMobileAlt />, text: "Mobile Apps", color: "from-purple-400 to-pink-500", bgColor: "from-purple-500/20 to-pink-600/20" },
                                    { icon: <FaLock />, text: "Data Encrypted", color: "from-yellow-400 to-orange-500", bgColor: "from-yellow-500/20 to-orange-600/20" }
                                ].map((item, idx) => (
                                    <div 
                                        key={idx} 
                                        className="group relative bg-gradient-to-br bg-white/15 backdrop-blur-lg rounded-2xl p-6 md:p-8 border-2 border-white/30 hover:border-white/60 transition-all duration-300 transform hover:scale-110 hover:-translate-y-2 shadow-2xl hover:shadow-3xl overflow-hidden"
                                    >
                                        {/* Animated Background Gradient */}
                                        <div className={`absolute inset-0 bg-gradient-to-br ${item.bgColor} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                                        
                                        {/* Icon Container */}
                                        <div className="relative z-10 mb-4 flex justify-center">
                                            <div className={`p-4 rounded-2xl bg-gradient-to-br ${item.color} shadow-lg group-hover:shadow-2xl transition-all duration-300 transform group-hover:rotate-6`}>
                                                <div className="text-3xl md:text-4xl text-white">
                                                    {item.icon}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Text */}
                                        <div className="relative z-10 text-white text-sm md:text-base font-bold text-center" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
                                            {item.text}
                                        </div>
                                        
                                        {/* Shine Effect */}
                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Scroll Indicator */}
                    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                        <div className="flex flex-col items-center gap-2">
                            <span className="text-white/80 text-sm font-medium" style={{ textShadow: '0 2px 5px rgba(0,0,0,0.5)' }}>Scroll to explore</span>
                            <FaArrowRight className="text-white/80 text-xl rotate-90" />
                        </div>
                    </div>
                </section>

                {/* Suite Selection */}
                <section className="py-12 bg-white">
                    <div className="container mx-auto px-4">
                        <h2 data-aos="fade-up" className="text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900">
                            Choose Your Perfect Suite
                        </h2>
                        <div className="flex flex-wrap justify-center gap-4 max-w-5xl mx-auto">
                            {[
                                "Smart School Suite",
                                "Enterprise Suite for Big Schools",
                                "Institutional & College Master Suite",
                                "Coaching & Training Academy Suite"
                            ].map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    data-aos="fade-up"
                                    className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 ${
                                        activeTab === tab 
                                            ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg" 
                                            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                        }`}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div data-aos="fade-up" className="mt-8 text-center max-w-3xl mx-auto">
                            <p className="text-lg text-gray-600">
                                {activeTab === "Smart School Suite" && "A complete digital solution designed for modern schools to simplify administration, enhance student engagement, and optimize daily academic operations with cutting-edge technology."}
                                {activeTab === "Enterprise Suite for Big Schools" && "A high-performance platform built specifically for large schools, offering advanced management tools, seamless communication channels, and scalable systems to handle thousands of users effortlessly."}
                                {activeTab === "Institutional & College Master Suite" && "An all-in-one, enterprise-grade solution crafted for colleges and educational institutions, streamlining campus-wide administration, academic delivery, and data management with powerful, customizable modules."}
                                {activeTab === "Coaching & Training Academy Suite" && "A specialized platform tailored for coaching centers and training academies, empowering them to manage batches, schedules, student performance, and communications — all from one unified system."}
                            </p>
                    </div>
                    </div>
                </section>

                {/* AI-Powered Features Highlight */}
                <section className="py-20 bg-gradient-to-r from-purple-900 via-blue-900 to-indigo-900 relative overflow-hidden">
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl"></div>
                        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
                    </div>
                    <div className="container mx-auto px-4 relative z-10">
                        <div className="text-center mb-16" data-aos="fade-up">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                                Advanced AI Learning System
                            </h2>
                            <p className="text-xl text-blue-200 max-w-3xl mx-auto">
                                Experience the future of education with our revolutionary AI-powered mentorship and learning intelligence system that personalizes education for every student.
                            </p>
                                </div>

                        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                            {[
                                {
                                    icon: <FaBrain className="text-5xl" />,
                                    title: "AI Mentorship",
                                    description: "Personalized learning paths and intelligent recommendations based on individual student performance and learning patterns."
                                },
                                {
                                    icon: <FaChartLine className="text-5xl" />,
                                    title: "Predictive Analytics",
                                    description: "Advanced analytics that predict student performance, identify at-risk students, and suggest intervention strategies."
                                },
                                {
                                    icon: <FaRocket className="text-5xl" />,
                                    title: "Smart Automation",
                                    description: "Automated workflows for admissions, fee collection, attendance, and administrative tasks powered by AI."
                                }
                            ].map((feature, idx) => (
                                <div 
                                    key={idx} 
                                    data-aos="fade-up" 
                                    data-aos-delay={idx * 100}
                                    className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:scale-105"
                                >
                                    <div className="text-yellow-400 mb-4 flex justify-center">{feature.icon}</div>
                                    <h3 className="text-2xl font-bold text-white mb-4 text-center">{feature.title}</h3>
                                    <p className="text-blue-200 text-center">{feature.description}</p>
                            </div>
                            ))}
                    </div>
                    </div>
                </section>

                {/* Comprehensive Features Section */}
                <section className="py-20 bg-gray-50">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-16" data-aos="fade-up">
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                                Complete Feature Suite
                            </h2>
                            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                                Everything you need to manage your educational institution efficiently, all in one powerful platform
                            </p>
                </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {features.map((feature, idx) => (
                                <div
                                    key={idx}
                                    data-aos="fade-up"
                                    data-aos-delay={idx * 50}
                                    className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
                                >
                                    <div className={`inline-flex p-4 rounded-xl bg-gradient-to-r ${feature.color} text-white mb-6`}>
                                        {feature.icon}
                                    </div>
                                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                                    <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Why Choose Us */}
                <section className="py-20 bg-white">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-16" data-aos="fade-up">
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                                Why Choose Educational Eternity?
                            </h2>
                        </div>
                        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                            {[
                                { 
                                    icon: <FaRocket className="text-5xl" />, 
                                    title: "Lightning-Fast Automation", 
                                    desc: "Save time with automated admissions, fee reminders, and attendance—powered by advanced AI. Reduce manual work by up to 80%." 
                                },
                                { 
                                    icon: <FaShieldAlt className="text-5xl" />, 
                                    title: "High-Grade Security", 
                                    desc: "Your institution's sensitive data is protected with enterprise-level security, encryption, and compliance with international standards." 
                                },
                                { 
                                    icon: <FaChartLine className="text-5xl" />, 
                                    title: "Seamless User Experience", 
                                    desc: "Intuitive dashboards for admins, teachers, students, and parents—no tech expertise required. Beautiful, modern interface." 
                                }
                            ].map((feature, idx) => (
                                <div 
                                    key={idx} 
                                    data-aos="fade-up" 
                                    data-aos-delay={idx * 100}
                                    className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-center"
                                >
                                    <div className="text-blue-600 mb-6 flex justify-center">{feature.icon}</div>
                                    <h4 className="text-2xl font-bold mb-4 text-gray-900">{feature.title}</h4>
                                    <p className="text-gray-600 leading-relaxed">{feature.desc}</p>
                            </div>
                        ))}
                        </div>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700">
                    <div className="container mx-auto px-4">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                            {[
                                { icon: <FaRocket />, end: 20, label: "Number Of Clients", suffix: "+" },
                                { icon: <FaUsers />, end: 55000, label: "Active Users", suffix: "+" },
                                { icon: <FaUserTie />, end: 10, label: "Expert Team Members", suffix: "+" },
                                { icon: <FaChartLine />, end: 10, label: "Number of Cities", suffix: "+" }
                            ].map((item, index) => (
                                <div 
                                    key={index} 
                                    data-aos="fade-up" 
                                    data-aos-delay={index * 100}
                                    className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 text-center"
                                >
                                    <div className="text-4xl text-yellow-400 mb-4 flex justify-center">{item.icon}</div>
                                    <div className="text-5xl font-bold text-white mb-2">
                                        <Counter end={item.end} />{item.suffix}
                    </div>
                                    <div className="text-blue-200 font-semibold text-lg">{item.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="py-20 bg-gray-100">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-12" data-aos="fade-up">
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                                Choose Your Plan
                            </h2>
                            <p className="text-xl text-gray-600 mb-8">
                                Flexible pricing plans designed for institutions of all sizes
                            </p>
                            <div className="flex justify-center space-x-4 mb-12">
                        <button
                                    className={`px-6 py-3 rounded-full font-semibold transition-all ${
                                        billingCycle === "monthly" 
                                            ? "bg-blue-600 text-white shadow-lg" 
                                            : "bg-white text-gray-700 hover:bg-gray-50"
                                    }`}
                            onClick={() => setBillingCycle("monthly")}
                        >
                            Monthly
                        </button>
                        <button
                                    className={`px-6 py-3 rounded-full font-semibold transition-all ${
                                        billingCycle === "yearly" 
                                            ? "bg-blue-600 text-white shadow-lg" 
                                            : "bg-white text-gray-700 hover:bg-gray-50"
                                    }`}
                            onClick={() => setBillingCycle("yearly")}
                        >
                                    Yearly <span className="text-sm text-green-600 ml-1">(Save 20%)</span>
                        </button>
                    </div>
                        </div>
                        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                        {plans.map((plan, index) => (
                                <div
                                    key={index}
                                    data-aos="fade-up"
                                    data-aos-delay={index * 100}
                                    className={`bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col relative ${
                                        plan.popular ? 'border-4 border-blue-500 scale-105' : 'border border-gray-200'
                                    }`}
                                >
                                    {plan.popular && (
                                        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full text-sm font-bold">
                                            Most Popular
                                        </div>
                                    )}
                                    <h3 className="text-2xl font-bold mb-4 text-gray-900">{plan.name}</h3>
                                    <div className="mb-6">
                                {billingCycle === "yearly" ? (
                                            plan.Yearly_price === "Free" ? (
                                                <div>
                                                    <span className="text-4xl font-bold text-gray-900">{plan.Yearly_price}</span>
                                                </div>
                                            ) : (
                                                <div>
                                                    <span className="text-4xl font-bold text-gray-900">₹ {plan.Yearly_price}</span>
                                                    <span className="text-gray-600 ml-2">/year</span>
                                                </div>
                                            )
                                ) : (
                                            plan.Monthly_price === "Free" ? (
                                                <div>
                                                    <span className="text-4xl font-bold text-gray-900">{plan.Monthly_price}</span>
                                                </div>
                                            ) : (
                                                <div>
                                                    <span className="text-4xl font-bold text-gray-900">₹ {plan.Monthly_price}</span>
                                                    <span className="text-gray-600 ml-2">/month</span>
                                                </div>
                                            )
                                )}
                                        {plan.users && (
                                            <div className="mt-3 text-sm text-gray-600">
                                                <span className="font-semibold">Up to {plan.users} users</span>
                                            </div>
                                        )}
                                    </div>
                                    <ul className="space-y-3 mb-8 flex-grow">
                                    {plan.details.map((detail, i) => (
                                            <li key={i} className="flex items-start">
                                                <FaCheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" />
                                                <span className="text-gray-700">{detail}</span>
                                            </li>
                                    ))}
                                </ul>
                                    <button
                                        onClick={openAddPlanModal}
                                        className={`w-full py-4 rounded-xl font-bold text-lg transition-all ${
                                            plan.popular
                                                ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:shadow-lg'
                                                : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                                        }`}
                                    >
                                        Get Started
                                    </button>
                            </div>
                        ))}
                    </div>
                </div>
                </section>

                {/* Testimonials */}
                <section className="py-20 bg-white">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-16" data-aos="fade-up">
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                                What Our Clients Say
                            </h2>
                            <p className="text-xl text-gray-600">
                                Trusted by leading educational institutions across India
                            </p>
                        </div>
                        <div className="max-w-6xl mx-auto">
                            <Carousel autoplay autoplaySpeed={5000} dots={true} className="testimonial-carousel">
                                {testimonials.map((testimonial, idx) => (
                                    <div key={idx} className="px-4">
                                        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 text-center">
                                            <div className="flex justify-center mb-4">
                                                {[...Array(testimonial.rating)].map((_, i) => (
                                                    <FaStar key={i} className="text-yellow-400 text-2xl mx-1" />
                                                ))}
                                            </div>
                                            <p className="text-xl md:text-2xl text-gray-700 italic mb-6 leading-relaxed">
                                                "{testimonial.quote}"
                                            </p>
                                            <div>
                                                <p className="text-lg font-bold text-gray-900">{testimonial.name}</p>
                                                <p className="text-gray-600">{testimonial.designation}</p>
                                            </div>
                                        </div>
                                </div>
                            ))}
                        </Carousel>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <section className="py-20 bg-gray-50">
                    <div className="container mx-auto px-4 max-w-4xl">
                        <div className="text-center mb-16" data-aos="fade-up">
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                                Frequently Asked Questions
                            </h2>
                            <p className="text-xl text-gray-600">
                                Everything you need to know about Educational Eternity
                            </p>
                        </div>
                        <Collapse 
                            accordion 
                            size="large"
                            items={faqs.map((faq, i) => ({
                                key: i,
                                label: <span className="text-lg font-semibold">{faq.q}</span>,
                                children: <p className="text-gray-700 leading-relaxed">{faq.a}</p>
                            }))}
                            className="bg-white rounded-xl shadow-lg"
                        />
                    </div>
                </section>

                {/* CTA Section */}
                <section className="py-20 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 relative overflow-hidden">
                    <div className="absolute inset-0 opacity-20">
                        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400 rounded-full filter blur-3xl"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-400 rounded-full filter blur-3xl"></div>
                                    </div>
                    <div className="container mx-auto px-4 text-center relative z-10" data-aos="fade-up">
                        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                            Ready to Transform Your Institution?
                        </h2>
                        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                            Join thousands of educational institutions already using Educational Eternity to streamline their operations and enhance learning outcomes.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                onClick={openAddPlanModal}
                                className="px-8 py-4 bg-white text-blue-600 rounded-full text-lg font-bold shadow-2xl hover:shadow-white/50 transform hover:scale-105 transition-all duration-300"
                            >
                                Schedule Free Demo
                            </button>
                            <Link to="/contact">
                                <button className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full text-lg font-bold hover:bg-white hover:text-blue-600 transform hover:scale-105 transition-all duration-300">
                                    Contact Us
                                </button>
                            </Link>
                                </div>
                    </div>
                </section>

                {/* Demo Modal */}
                <ModalComponent 
                    isOpen={isOpenPlanModal} 
                    setIsOpen={setIsOpenPlanModal} 
                    title={'Schedule a Free Demo - Educational Eternity'} 
                    width={900}
                >
                    <Form 
                        className='w-full' 
                        autoComplete="off" 
                        form={form} 
                        initialValues={initialValues} 
                        onFinish={handleSubmit} 
                        onFieldsChange={handleFieldsChange}
                    >
                        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">First Name</label>
                                <Form.Item name="First_Name" rules={[{ required: true, message: 'Please enter First Name.' }]}>
                                    <Input placeholder="First name" className="mt-1 w-full ps-4 py-2" />
                                </Form.Item>
                            </div>
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Last Name</label>
                                <Form.Item name="Last_Name" rules={[{ required: true, message: 'Please enter Last Name.' }]}>
                                    <Input placeholder="Last name" className="mt-1 w-full ps-4 py-2" />
                                </Form.Item>
                            </div>
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Phone No</label>
                                <Form.Item name="Contact_Number" rules={[{ required: true, message: 'Please enter phone number.' }]}>
                                    <Input type="tel" placeholder="Phone no" className="mt-1 w-full ps-4 py-2" />
                                </Form.Item>
                            </div>
                            <div className="ant-select-selector-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">State</label>
                                <Form.Item name="State" rules={[{ required: true, message: "Please select a state." }]}>
                                    <Select 
                                        showSearch 
                                        placeholder="Select a state" 
                                        className="w-full mt-1" 
                                        filterOption={filterOption} 
                                        onChange={handleStateChange}
                                    >
                                        {Object.keys(stateDistricts).map((state) => (
                                            <Option key={state} value={state}>
                                                {state}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="ant-select-selector-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">District</label>
                                <Form.Item name="District" rules={[{ required: true, message: "Please select a district." }]}>
                                    <Select 
                                        showSearch 
                                        placeholder="Select a district" 
                                        className="w-full mt-1" 
                                        filterOption={filterOption} 
                                        disabled={!selectedState}
                                    >
                                        {districtOptions.map((district) => (
                                            <Option key={district} value={district}>
                                                {district}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Other Phone No (optional)</label>
                                <Form.Item name="Secondary_Contact">
                                    <Input type="tel" placeholder="Phone no" className="mt-1 w-full ps-4 py-2" />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='input-white mt-3'>
                            <label className='text-base text-[#2F2B3DCC] font-medium'>Address</label>
                            <Form.Item name="Address" rules={[{ required: true, message: 'Please enter address.' }]}>
                                <TextArea 
                                    className="mt-1" 
                                    placeholder="Enter your complete address" 
                                    autoSize={{ minRows: 4, maxRows: 6 }} 
                                />
                            </Form.Item>
                        </div>
                        <div className="flex justify-center items-center mt-7 gap-5">
                            <LoadableButton
                                type="submit"
                                className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium px-10 py-3 rounded-lg hover:shadow-lg duration-500"
                                lable="Submit Request"
                                disabled={!isFormChanged || isSubmitLoading}
                                isLoading={isSubmitLoading}
                                loadingLable="Submitting..."
                            />
                        </div>
                    </Form>
                </ModalComponent>
            </Layout>
        </div>
    );
};

export default HomePage;
